import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { filter } from 'rxjs/operators';

const ERROR_ROUTE_PATTERN: RegExp = /^\/dashboard\/(400|403|404|429|500)(?=$|[/?#])/;
const HISTORY_LIMIT: number = 10;

@Injectable({
  providedIn: 'root',
})
export class NavigationHistoryService {
  private readonly router = inject(Router);
  private readonly fallbackUrl: string = '/dashboard';
  private history: string[] = [];

  init(): void {
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      const url: string = event.urlAfterRedirects;
      if (this.isErrorUrl(url) || this.history[this.history.length - 1] === url) {
        return;
      }
      this.history = [...this.history, url].slice(-HISTORY_LIMIT);
    });
  }

  getPreviousUrl(): string {
    const currentUrl: string = this.router.url;
    for (let i = this.history.length - 1; i >= 0; i--) {
      if (this.history[i] !== currentUrl) {
        return this.history[i];
      }
    }

    return this.fallbackUrl;
  }

  private isErrorUrl(url: string): boolean {
    return ERROR_ROUTE_PATTERN.test(url);
  }
}
